import { LegacyEmployee, RbacEmployee } from './types';

/**
 * The shared RBAC employee in the legacy employee form's shape (organizations list, subdivisions). The form fills
 * its inputs with '' for the missing values, as BMS's former employees endpoint did through the shared slice.
 */
export const toLegacyEmployee = (employee: RbacEmployee): LegacyEmployee => ({
  ...employee,
  email: employee.email ?? '',
  phoneNumber: employee.phoneNumber ?? '',
  startDate: employee.startDate ?? '',
  endDate: employee.endDate ?? '',
  organization: { id: employee.organizationId },
  department: { id: employee.departmentId, value: employee.departmentName },
  position: { id: employee.positionId, value: employee.positionName },
  roles: (employee.roles ?? []).map(({ roleId, roleName }) => ({
    id: roleId,
    name: roleName,
  })),
});
